const TAILLE=(u,w)=>typeof u!=='string'?u:/[?&]width=\d+/.test(u)?u.replace(/([?&])width=\d+/,'$1width='+w):/\/cdn\/shop\/.+\.(jpe?g|png)(\?|$)/i.test(u)?u+(u.includes('?')?'&':'?')+'width='+w:u;
const JEU_T=u=>`${TAILLE(u,500)} 500w, ${TAILLE(u,800)} 800w, ${TAILLE(u,1100)} 1100w`;
/* MAISON PIEGE* · motion + boutique démo (GSAP + ScrollTrigger + Lenis) */
(function(){
/* l'étoile Maison Piège remplace chaque astérisque affiché, y compris ceux écrits plus tard par les scripts */
(()=>{const LILAS=['rgb(204, 193, 255)'];
const teinter=r=>requestAnimationFrame(()=>{for(const e of (r.querySelectorAll?r.querySelectorAll('.etoile'):[]))if(LILAS.includes(getComputedStyle(e).color))e.classList.add('etoile-blanche')});
const exclus='script,style,title,textarea,select,option,svg,.etoile';
const poser=r=>{if(!r||r.nodeType!==1)return;const w=document.createTreeWalker(r,NodeFilter.SHOW_TEXT,{acceptNode:n=>n.nodeValue.includes('*')&&!n.parentElement.closest(exclus)?1:2}),ns=[];
  while(w.nextNode())ns.push(w.currentNode);
  for(const n of ns){const f=document.createDocumentFragment();n.nodeValue.split('*').forEach((t,i)=>{if(i){const e=document.createElement('i');e.className='etoile';e.setAttribute('aria-hidden','true');f.append(e)}if(t)f.append(t)});n.replaceWith(f)}teinter(r)};
poser(document.body);
new MutationObserver(ms=>{for(const m of ms)for(const n of m.addedNodes)poser(n.nodeType===3?n.parentNode:n)}).observe(document.body,{childList:true,subtree:true})})();
const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
document.body.classList.remove('no-js');
if(!reduced)document.body.classList.add('js-fx');

/* Grain : un vrai élément, pas body::after. Safari 26 cherche la barre du haut en sondant l'élément le plus haut à 4 px du bord ;
   un pseudo-élément de body lui répond « body » et il abandonne, alors qu'il passe outre un calque presque transparent (< 0,1) qui ignore le pointeur. */
{const g=document.createElement('div');g.className='grain';g.setAttribute('aria-hidden','true');document.body.append(g)}

/* rideau d'entrée */
const reveal=()=>requestAnimationFrame(()=>requestAnimationFrame(()=>setTimeout(()=>document.body.classList.add('is-loaded'),120)));
document.readyState!=='loading'?reveal():document.addEventListener('DOMContentLoaded',reveal);
setTimeout(()=>document.body.classList.add('is-loaded'),1800);
/* retour via le cache navigateur (bouton retour) : ne pas rester bloqué sur le rideau */
addEventListener('pageshow',e=>{if(e.persisted){document.body.classList.remove('is-leaving');document.body.classList.add('is-loaded')}});

/* transitions de page */
document.addEventListener('click',e=>{
  const a=e.target.closest('a');
  if(!a||reduced)return;
  const h=a.getAttribute('href')||'';
  if(!h.startsWith('/')||h.startsWith('//')||/^\/(cart|checkout|account)/.test(h)||a.target==='_blank'||e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;
  e.preventDefault();
  document.body.classList.add('is-leaving');
  setTimeout(()=>location.href=h,460);
});

/* curseur : délégation (fonctionne aussi sur les éléments créés en JS) */
const cur=document.querySelector('.cursor');
if(cur&&matchMedia('(hover:hover)').matches){
  addEventListener('mousemove',e=>{cur.style.left=e.clientX+'px';cur.style.top=e.clientY+'px'});
  document.addEventListener('mouseover',e=>{
    cur.classList.toggle('is-view',!!e.target.closest('.card'));
    cur.classList.toggle('is-link',!!e.target.closest('a,button')&&!e.target.closest('.card'));
  });
}

/* vidéos de section : lecture seulement à l'écran (perf + fluidité) */
const vids=document.querySelectorAll('video.lazyvid');
if(vids.length&&'IntersectionObserver' in window){
  const io=new IntersectionObserver(es=>es.forEach(e=>{
    if(e.isIntersecting){e.target.dataset.vis=1;e.target.play().catch(()=>{})}
    else{delete e.target.dataset.vis;e.target.pause()}
  }),{threshold:.2});
  vids.forEach(v=>io.observe(v));
}
/* iOS (économie d'énergie) refuse parfois l'autoplay : le moindre geste relance les vidéos visibles */
const kick=()=>document.querySelectorAll('video').forEach(v=>{
  if(v.paused&&(v.hasAttribute('autoplay')||v.dataset.vis))v.play().catch(()=>{})});
addEventListener('touchend',kick,{passive:true});
addEventListener('touchstart',kick,{passive:true});
/* le hero se lance dès que la vidéo peut jouer, sans attendre un geste (retours du 15.10 : il fallait « pianoter ») */
document.querySelectorAll('video[autoplay]').forEach(v=>{v.muted=true;v.playsInline=true;
  ['loadedmetadata','canplay'].forEach(t=>v.addEventListener(t,()=>{if(v.paused)v.play().catch(()=>{})}));
  if(v.readyState>=2&&v.paused)v.play().catch(()=>{})});
addEventListener('click',kick,true);
addEventListener('pageshow',kick);

/* menu mobile */
const burger=document.querySelector('.burger'),menu=document.querySelector('.menu');
if(burger&&menu){
  /* menu ouvert : la page derrière est figée à sa place, le doigt ne fait défiler que le menu (retours du 15.10) */
  let yMenu=0;
  const figer=()=>{yMenu=scrollY;window.__lenis&&window.__lenis.stop();const b=document.body.style;
    document.documentElement.classList.add('menu-ouvert');b.position='fixed';b.top=-yMenu+'px';b.left='0';b.right='0'};
  const liberer=()=>{if(!document.documentElement.classList.contains('menu-ouvert'))return;const b=document.body.style;
    document.documentElement.classList.remove('menu-ouvert');b.position=b.top=b.left=b.right='';
    window.scrollTo(0,yMenu);if(window.__lenis){window.__lenis.scrollTo(yMenu,{immediate:true});
    if(!document.body.classList.contains('search-open'))window.__lenis.start()}};   /* la recherche ouverte depuis le menu garde la page figée */
  burger.addEventListener('click',()=>{menu.classList.add('open');figer()});
  menu.querySelector('.close').addEventListener('click',()=>{menu.classList.remove('open');liberer()});
  /* un lien du menu vers la même page (ancre) ou retour arrière : on libère aussi */
  menu.addEventListener('click',e=>{if(e.target.closest('a'))liberer()});
  addEventListener('pageshow',()=>{if(!menu.classList.contains('open'))liberer()});
  /* menu posé : la page derrière devient invisible, les bords de Safari (heure, barre d'adresse) ne montrent plus que le fond noir */
  let tPlein;new MutationObserver(()=>{clearTimeout(tPlein);if(menu.classList.contains('open'))tPlein=setTimeout(()=>document.documentElement.classList.add('menu-plein'),520);else{document.documentElement.classList.remove('menu-plein');liberer()}}).observe(menu,{attributes:true,attributeFilter:['class']});
}

/* aftermovie : il se regarde sur place, sans quitter la boutique pour Instagram. Croix, Échap ou clic à côté pour refermer. */
document.querySelectorAll('[data-film]').forEach(a=>a.addEventListener('click',e=>{
  e.preventDefault();
  const ov=document.createElement('div');ov.className='film-ov';ov.setAttribute('role','dialog');ov.setAttribute('aria-label',"Aftermovie du pop-up");
  ov.innerHTML=`<button class="film-x" aria-label="Fermer">FERMER ✕</button><video src="${a.dataset.film}" poster="${a.dataset.affiche||''}" controls autoplay playsinline></video>`;
  document.body.append(ov);document.body.classList.add('film-ouvert');
  const v=ov.querySelector('video');v.play().catch(()=>{});
  const fermer=()=>{v.pause();ov.remove();document.body.classList.remove('film-ouvert');removeEventListener('keydown',clavier)};
  const clavier=e=>{if(e.key==='Escape')fermer()};
  ov.querySelector('.film-x').addEventListener('click',fermer);ov.addEventListener('click',e=>{if(e.target===ov)fermer()});addEventListener('keydown',clavier);
  ov.querySelector('.film-x').focus();
}));

/* ---- effets scroll (re-appelables pour le contenu dynamique) ---- */
window.bindFx=function(){
  if(reduced||typeof gsap==='undefined')return;
  gsap.registerPlugin(ScrollTrigger);
  document.querySelectorAll('.rv:not([data-fx])').forEach(el=>{el.dataset.fx=1;
    gsap.to(el,{opacity:1,y:0,duration:.9,ease:'power3.out',scrollTrigger:{trigger:el,start:'top 88%'}})});
  document.querySelectorAll('.rv-img:not([data-fx])').forEach(el=>{el.dataset.fx=1;
    gsap.to(el,{clipPath:'inset(0% 0 0 0)',duration:1.1,ease:'power4.out',scrollTrigger:{trigger:el,start:'top 85%'}})});
  document.querySelectorAll('.fenetre img:not([data-fx])').forEach(img=>{img.dataset.fx=1;
    gsap.fromTo(img,{yPercent:-5},{yPercent:5,ease:'none',
      scrollTrigger:{trigger:img.closest('.fenetre'),start:'top bottom',end:'bottom top',scrub:true}})});
  document.querySelectorAll('.flashable:not([data-fx])').forEach(el=>{el.dataset.fx=1;
    ScrollTrigger.create({trigger:el,start:'top 72%',once:true,
      onEnter:()=>{el.classList.add('flash');setTimeout(()=>el.classList.remove('flash'),600)}})});
  document.querySelectorAll('.reflect:not([data-fx2])').forEach(el=>{el.dataset.fx2=1;
    ScrollTrigger.create({trigger:el,start:'top 70%',once:true,onEnter:()=>el.classList.add('sweep')});
    el.addEventListener('mouseenter',()=>{el.classList.remove('sweep');void el.offsetWidth;el.classList.add('sweep')})});
  document.querySelectorAll('.code-line[data-text]:not([data-fx])').forEach(el=>{el.dataset.fx=1;
    const txt=el.dataset.text;el.innerHTML='<span class="t"></span><span class="caret">|</span>';
    const t=el.querySelector('.t');
    ScrollTrigger.create({trigger:el,start:'top 88%',once:true,onEnter:()=>{
      let i=0;const iv=setInterval(()=>{t.textContent=txt.slice(0,++i);if(i>=txt.length)clearInterval(iv)},34)}})});
  document.querySelectorAll('.ch-titre:not([data-fx])').forEach((el,i)=>{el.dataset.fx=1;
    gsap.fromTo(el,{xPercent:i%2?4:-4},{xPercent:i%2?-4:4,ease:'none',
      scrollTrigger:{trigger:el,start:'top bottom',end:'bottom top',scrub:true}})});
};

if(!reduced&&typeof gsap!=='undefined'){
  gsap.registerPlugin(ScrollTrigger);
  if(typeof Lenis!=='undefined'){
    const lenis=new Lenis({lerp:.1});window.__lenis=lenis;
    lenis.on('scroll',ScrollTrigger.update);
    gsap.ticker.add(t=>lenis.raf(t*1000));
    gsap.ticker.lagSmoothing(0);
  }
  bindFx();
  /* recalage des déclencheurs quand les images ont fini de charger (sinon
     les sections basses gardent des positions fausses : texte jamais tapé, etc.) */
  addEventListener('load',()=>ScrollTrigger.refresh());
  const heroMedia=document.querySelector('.hero video');
  if(heroMedia)gsap.to(heroMedia,{opacity:.42,ease:'none',
    scrollTrigger:{trigger:'.hero',start:'top top',end:'bottom top',scrub:true}});
}else if(typeof gsap==='undefined'){
  document.body.classList.add('no-js'); // CDN indisponible : tout rester visible
}
})();

/* ================= DROP 667 : compte à rebours, bordereau, billet ================= */
(function(){
  /* compte à rebours : js/rebours.js, chargé avant les bibliothèques */
  /* convoi : glisser à la souris, flèches, compteur ; le train entre en gare une fois à l'écran */
  const convoi=document.querySelector('.convoi');
  if(convoi){
    const wagons=[...convoi.querySelectorAll('.wg')],compte=document.querySelector('.cv-compte b');
    /* les secondes photos ne servent qu'au survol : on les charge au premier passage de la souris, pas au chargement */
    convoi.addEventListener('pointerenter',()=>convoi.querySelectorAll('.wg-alt[data-src]').forEach(i=>{i.src=i.dataset.src;i.removeAttribute('data-src')}),{once:true});
    const prec=document.querySelector('.cv-prec'),suiv=document.querySelector('.cv-suiv');
    const pas=()=>wagons[1]?wagons[1].offsetLeft-wagons[0].offsetLeft:convoi.clientWidth;
    const maj=()=>{const fin=convoi.scrollLeft>=convoi.scrollWidth-convoi.clientWidth-4;
      const i=fin?wagons.length-1:Math.round(convoi.scrollLeft/pas());
      if(compte)compte.textContent=String(i+1).padStart(2,'0');
      if(prec)prec.disabled=convoi.scrollLeft<4;if(suiv)suiv.disabled=fin};
    convoi.addEventListener('scroll',maj,{passive:true});maj();
    prec&&prec.addEventListener('click',()=>convoi.scrollBy({left:-pas(),behavior:'smooth'}));
    suiv&&suiv.addEventListener('click',()=>convoi.scrollBy({left:pas(),behavior:'smooth'}));
    let down=false,sx=0,sl=0,bouge=false;
    convoi.addEventListener('pointerdown',e=>{if(e.pointerType!=='mouse'||e.button)return;down=true;bouge=false;sx=e.clientX;sl=convoi.scrollLeft});
    addEventListener('pointermove',e=>{if(!down)return;const d=e.clientX-sx;
      if(!bouge&&Math.abs(d)>6){bouge=true;convoi.classList.add('glisse')}
      if(bouge)convoi.scrollLeft=sl-d});
    addEventListener('pointerup',()=>{if(!down)return;down=false;
      if(bouge){const i=Math.round(convoi.scrollLeft/pas());convoi.classList.remove('glisse');
        convoi.scrollTo({left:Math.min(i*pas(),convoi.scrollWidth),behavior:'smooth'})}});
    convoi.addEventListener('dragstart',e=>e.preventDefault());
    /* les photos des premiers wagons se chargent avant que le convoi n'arrive à l'écran, et le train n'entre en gare
       qu'une fois ses photos prêtes (900 ms au plus) : sinon Safari faisait entrer des wagons vides, la photo surgissait après */
    const precharger=()=>wagons.slice(0,3).forEach(w=>w.querySelectorAll('.wg-photo img:not(.wg-alt)').forEach(i=>{i.loading='eager';i.fetchPriority='high'}));
    if('IntersectionObserver' in window)new IntersectionObserver((es,o)=>{if(es.some(e=>e.isIntersecting)){precharger();o.disconnect()}},{rootMargin:'0px 0px 900px 0px'}).observe(convoi);
    const gare=()=>{if(convoi.classList.contains('arrive')||convoi.dataset.attend)return;convoi.dataset.attend='1';precharger();
      const ims=wagons.slice(0,2).map(w=>w.querySelector('.wg-photo img:not(.wg-alt)')).filter(Boolean);
      Promise.race([Promise.all(ims.map(i=>i.decode().catch(()=>0))),new Promise(r=>setTimeout(r,900))])
        .then(()=>{convoi.scrollLeft=0;convoi.classList.add('arrive')})};
    const vu=()=>{const r=convoi.getBoundingClientRect();return r.top<innerHeight*.88&&r.bottom>0};
    if('IntersectionObserver' in window)new IntersectionObserver((es,o)=>es.forEach(e=>{if(e.isIntersecting&&vu()){gare();o.disconnect()}}),{threshold:[0,.2,.5]}).observe(convoi);
    const auScroll=()=>{if(vu()){gare();removeEventListener('scroll',auScroll)}};
    addEventListener('scroll',auScroll,{passive:true});auScroll();
  }

  /* coulures : la trame du film et le titre 667 dégoulinent comme le lettrage sérigraphié des pièces 667 :
     coulures épaisses en festons, dégradé tramé du clair vers l'encre, liseré blanc (le contour noir de
     l'imprimé disparaît sur le fond noir, il ne reste que le liseré). Un seul SVG par zone, peint dans
     l'ordre des sérigraphes : tous les liserés d'abord, toutes les encres ensuite, pour que les gouttes
     se fondent dans la lettre sans trait à la jointure. Tirage fixe : le dessin est le même à chaque visite. */
  const hasard=graine=>()=>{graine|=0;graine=graine+0x6D2B79F5|0;let t=Math.imul(graine^graine>>>15,1|graine);
    t=t+Math.imul(t^t>>>7,61|t)^t;return((t^t>>>14)>>>0)/4294967296};
  /* encres relevées au pixel, rangée par rangée, dans les lettres de l'imprimé (06.10) :
     bleu : même dégradé que le dos de la veste, mais à la teinte relevée sur la veste et le pantalon de face (225-239°,
     un bleu foncé, pas un violet) : corps saturé, trame plus sombre, pied bleu nuit ; rouge sur le dos du t-shirt :
     corail saturé dès le haut, qui fonce en cramoisi, coulures bordeaux */
  const ENCRE={bleu:{clair:'#3B57CF',moyen:'#2E45B8',fonce:'#1A2A8F',goutte:'#15237A'},rouge:{clair:'#EC445B',moyen:'#E23C57',fonce:'#B02544',goutte:'#8D1534'}};
  const f1=n=>n.toFixed(1);
  /* une coulure : col évasé dans la matière, tige qui ondule, perle au bout ; ou un simple feston.
     Renvoie le tracé plein (avec la partie cachée dans la matière) et le tracé du liseré (ouvert en haut). */
  const coulee=(cx,base,W,L,ov,rnd,longue)=>{
    if(!longue){const h=W/2,y=base+L*1.33;
      const bas=`C${f1(cx-h*.92)} ${f1(y)} ${f1(cx+h*.92)} ${f1(y)} ${f1(cx+h)} ${f1(base)}`;
      return{plein:`M${f1(cx-h)} ${f1(base-ov)}V${f1(base)}${bas}V${f1(base-ov)}Z`,trait:`M${f1(cx-h)} ${f1(base)}${bas}`}}
    const s=W*(.48+rnd()*.14),r=s*.62,fh=Math.min((W-s)*.85,L*.3),yN=base+L-r*1.7,y1=base+fh,w1=(rnd()-.5)*s*.5,w2=(rnd()-.5)*s*.5;
    const bas=`C${f1(cx-s/2-(W-s)*.15)} ${f1(base)} ${f1(cx-s/2)} ${f1(base+fh*.4)} ${f1(cx-s/2)} ${f1(y1)}`+
      `C${f1(cx-s/2+w1)} ${f1(y1+(yN-y1)*.4)} ${f1(cx-s*.42+w2)} ${f1(y1+(yN-y1)*.75)} ${f1(cx-s*.42)} ${f1(yN)}`+
      `C${f1(cx-r*1.14)} ${f1(yN+r*.35)} ${f1(cx-r*1.06)} ${f1(base+L)} ${f1(cx)} ${f1(base+L)}`+
      `C${f1(cx+r*1.06)} ${f1(base+L)} ${f1(cx+r*1.14)} ${f1(yN+r*.35)} ${f1(cx+s*.42)} ${f1(yN)}`+
      `C${f1(cx+s*.42+w2)} ${f1(y1+(yN-y1)*.75)} ${f1(cx+s/2+w1)} ${f1(y1+(yN-y1)*.4)} ${f1(cx+s/2)} ${f1(y1)}`+
      `C${f1(cx+s/2)} ${f1(base+fh*.4)} ${f1(cx+s/2+(W-s)*.15)} ${f1(base)} ${f1(cx+W/2)} ${f1(base)}`;
    return{plein:`M${f1(cx-W/2)} ${f1(base-ov)}V${f1(base)}${bas}V${f1(base-ov)}Z`,trait:`M${f1(cx-W/2)} ${f1(base)}${bas}`,r}};
  /* festonne un segment [a,b] : festons serrés, et de vraies coulures de place en place */
  const festonner=(a,b,base,o)=>{const out=[];let x=a+o.rnd()*o.wMin*.3;
    while(x<b){const longue=o.rnd()<o.pLongue;
      let W=longue?o.wMin+o.rnd()*(o.wMax-o.wMin):o.wMin*1.1+o.rnd()*(o.wMax*1.3-o.wMin);
      const cx=Math.min(Math.max(x+W/2,a+W/2),b-W/2);if(b-a<W){W=b-a;}
      if(W>o.wMin*.6){const L=longue?o.lMin+Math.pow(o.rnd(),1.4)*(o.lMax-o.lMin):o.fMin+o.rnd()*(o.fMax-o.fMin);
        const c=coulee(b-a<W*1.01?(a+b)/2:cx,base,W,L,o.ov,o.rnd,longue);
        out.push({...c,x:cx,bas:base+L,L,longue,del:o.rnd()*o.retard})}
      x+=W*(longue?.85:.6)}
    return out};
  const svgEl=(w,h)=>{const e=document.createElementNS('http://www.w3.org/2000/svg','svg');e.setAttribute('width',f1(w));e.setAttribute('height',f1(h));
    e.setAttribute('viewBox',`0 0 ${f1(w)} ${f1(h)}`);e.setAttribute('aria-hidden','true');e.classList.add('coulures');return e};
  /* trame de sérigraphie : des points dont le rayon grossit entre y1 et y2, motif d'une colonne */
  const trame=(id,pas,y1,y2,h,fill)=>{let c='';const ry=pas/2;
    for(let i=0,y=y1;y<y2+ry;i++,y+=ry){const r=Math.min(1,(y-y1)/(y2-y1))*pas*.74,xp=i%2?pas/2:0;if(r<.25)continue;
      for(const x of[xp-pas,xp,xp+pas])c+=`<circle cx="${f1(x)}" cy="${f1(y)}" r="${r.toFixed(2)}"/>`}
    return `<pattern id="${id}" patternUnits="userSpaceOnUse" width="${pas}" height="${f1(h)}" fill="${fill}">${c}</pattern>`};
  const anim=(g,i)=>`class="dg" style="--L:${f1(g.L+4)};--dur:${(.9+g.L/150).toFixed(2)}s;--del:${g.del.toFixed(2)}s"`;
  let nZone=0;
  /* le film coule : la vidéo déborde sous le hero à travers un masque en festons, cernée du même liseré
     blanc que le titre. Le masque ne couvre que la bande du bas (taille fixe en pixels), le haut reste
     plein : la barre d'adresse du téléphone peut changer la hauteur du hero sans déformer les gouttes. */
  const tracerFilm=hero=>{
    const vid=hero.querySelector('video');if(!vid)return;
    hero.querySelector('svg.coulures')?.remove();
    const W=hero.clientWidth,mob=W<700,k=mob?.62:1,ov=3,lis=mob?1.3:1.7;
    const rnd=hasard(667),gouttes=festonner(0,W,ov,{rnd,ov,pLongue:.22,wMin:18*k,wMax:34*k,lMin:30*k,lMax:120*k,fMin:5*k,fMax:13*k,retard:0});
    const D=Math.ceil(Math.max(...gouttes.map(g=>g.L))+ov+lis*2+2);
    const formes=gouttes.map(g=>`<path d="${g.plein}"/>`).join('');
    const masque=`<svg xmlns="http://www.w3.org/2000/svg" width="${W}" height="${D}" viewBox="0 0 ${W} ${D}"><g fill="#fff"><rect width="${W}" height="${ov+.5}"/>${formes}</g></svg>`;
    const url=`url("data:image/svg+xml,${encodeURIComponent(masque)}")`;
    hero.style.setProperty('--D',D);
    Object.assign(vid.style,{bottom:'auto',height:`calc(100% + ${D-ov}px)`});
    for(const pre of['webkit','']){const P=n=>pre?pre+n[0].toUpperCase()+n.slice(1):n;
      vid.style[P('maskImage')]=`linear-gradient(#fff,#fff),${url}`;
      vid.style[P('maskSize')]=`100% calc(100% - ${D}px),100% ${D}px`;
      vid.style[P('maskPosition')]='top,bottom';vid.style[P('maskRepeat')]='no-repeat'}
    /* liseré : le trait de chaque feston, masqué à l'intérieur de leur union pour ne garder que le contour */
    const id='cf'+(++nZone),e=svgEl(W,D);e.classList.add('film-liseré');
    /* le liseré naît le long des gouttes : rien sur le bord du film, pour ne pas recréer de ligne de coupe */
    e.innerHTML=`<defs><linearGradient id="${id}g" gradientUnits="userSpaceOnUse" x1="0" x2="0" y1="${ov+3}" y2="${ov+22*k}"><stop offset="0" stop-color="#000"/><stop offset="1" stop-color="#fff"/></linearGradient>`+
      `<linearGradient id="${id}f" gradientUnits="userSpaceOnUse" x1="0" x2="0" y1="${ov}" y2="${D}"><stop offset="0" stop-color="#F4F4F2" stop-opacity="0"/><stop offset="1" stop-color="#F4F4F2" stop-opacity=".2"/></linearGradient>`+
      `<mask id="${id}" maskUnits="userSpaceOnUse"><rect width="${W}" height="${D}" fill="url(#${id}g)"/><g fill="#000"><rect width="${W}" height="${ov+.5}"/>${formes}</g></mask></defs>`+
      `<g fill="url(#${id}f)">${formes}</g>`+
      `<g mask="url(#${id})" fill="none" stroke="var(--blanc)" stroke-width="${lis*2}" stroke-linejoin="round">${gouttes.map(g=>`<path d="${g.trait}"/>`).join('')}</g>`;
    e.style.top=`calc(100% - ${ov}px)`;hero.appendChild(e);
    const H=hero.clientHeight;
    hero._perles=gouttes.filter(g=>g.longue).map(g=>({x:g.x,bas:H-ov+g.bas,r:g.r,c:'#262624'}))};
  /* le titre : on lit au canevas où chaque lettre touche la ligne de base, on festonne ces pieds */
  const tracerTitre=h=>{
    h.querySelector('svg.coulures')?.remove();h.classList.remove('fondu');
    const cs=getComputedStyle(h),taille=parseFloat(cs.fontSize),police=`${cs.fontWeight} ${taille}px ${cs.fontFamily}`;
    const noeud=[...h.childNodes].find(n=>n.nodeType===3&&n.textContent.trim());if(!noeud)return;
    const texte=noeud.textContent.toUpperCase(),ast=h.querySelector('span');
    const cv=document.createElement('canvas'),ctx=cv.getContext('2d');ctx.font=police;
    const m=ctx.measureText(texte),asc=m.fontBoundingBoxAscent||taille*.8,cap=ctx.measureText('M').actualBoundingBoxAscent||taille*.7;
    cv.width=Math.ceil(m.width+20);cv.height=Math.ceil(taille*1.3);ctx.font=police;
    const y0=Math.round(taille);ctx.fillText(texte,10,y0);
    const ov=Math.max(3,taille*.03),ligne=ctx.getImageData(0,Math.round(y0-ov),cv.width,1).data;
    const rg=document.createRange();rg.selectNodeContents(noeud);
    const rt=rg.getClientRects()[0],hb=h.getBoundingClientRect();if(!rt)return;
    const base=rt.top-hb.top+asc,x0=rt.left-hb.left,gauche=x0-10;
    /* frontière des encres : au milieu du X (moitié bleu, moitié rouge), sinon avant le M */
    const iX=texte.indexOf('X'),iM=texte.indexOf('M');let xs=Infinity;
    const boite=i=>{const r2=document.createRange();r2.setStart(noeud,i);r2.setEnd(noeud,i+1);return r2.getBoundingClientRect()};
    if(iX>0){const b=boite(iX);xs=(b.left+b.right)/2-hb.left}else if(iM>0)xs=boite(iM).left-hb.left;
    const runs=[];let deb=-1;
    for(let x=0;x<=cv.width;x++){const plein=x<cv.width&&ligne[x*4+3]>140;
      if(plein&&deb<0)deb=x;if(!plein&&deb>=0){runs.push([deb+gauche,x+gauche]);deb=-1}}
    const rnd=hasard(31),lis=Math.max(1.3,taille*.011);
    const o={rnd,ov,pLongue:.42,wMin:taille*.055,wMax:taille*.1,lMin:taille*.1,lMax:taille*.55,fMin:taille*.02,fMax:taille*.06,retard:.6};
    const gouttes=runs.filter(([a,b])=>b-a>taille*.04).flatMap(([a,b])=>festonner(a+1,b-1,base,o));
    const W=hb.width,H=base+Math.max(taille*.2,...gouttes.map(g=>g.L))+lis*2+6,id='ct'+(++nZone),e=svgEl(W,H);
    const fam=cs.fontFamily.replace(/"/g,"'"),attr=`font-family="${fam}" font-weight="${cs.fontWeight}" font-size="${taille}"`;
    const grad=(n,c)=>`<linearGradient id="${id}${n}" gradientUnits="userSpaceOnUse" x1="0" x2="0" y1="${f1(base-cap)}" y2="${f1(base)}"><stop offset="0" stop-color="${c.clair}"/><stop offset=".42" stop-color="${c.moyen}"/><stop offset=".8" stop-color="${c.fonce}"/></linearGradient>`;
    const lettres=(fill,extra='')=>`<g clip-path="url(#${id}g)"><text x="${f1(x0)}" y="${f1(base)}" ${attr} fill="${fill('bleu')}"${extra}>${texte}</text></g>`+
      `<g clip-path="url(#${id}d)"><text x="${f1(x0)}" y="${f1(base)}" ${attr} fill="${fill('rouge')}"${extra}>${texte}</text></g>`;
    const pas=Math.max(4,Math.round(taille*.032));
    let html=`<defs>${grad('b',ENCRE.bleu)}${grad('r',ENCRE.rouge)}${trame(id+'tb',pas,base-cap*.78,base-cap*.18,H,ENCRE.bleu.fonce)}${trame(id+'tr',pas,base-cap*.78,base-cap*.18,H,ENCRE.rouge.fonce)}`+
      `<clipPath id="${id}c"><rect y="${f1(base-ov)}" width="${W}" height="${H}"/></clipPath>`+
      `<clipPath id="${id}g"><rect x="${-W}" y="${f1(-H)}" width="${f1(Math.min(xs,2*W)+W)}" height="${f1(3*H)}"/></clipPath><clipPath id="${id}d"><rect x="${f1(Math.min(xs,2*W))}" y="${f1(-H)}" width="${3*W}" height="${f1(3*H)}"/></clipPath></defs>`;
    const encre=g=>g.x<xs?ENCRE.bleu.goutte:ENCRE.rouge.goutte;
    /* liserés : lettres puis coulures ; encres : dégradé, trame, coulures */
    html+=lettres(()=> 'none',` stroke="var(--blanc)" stroke-width="${f1(lis*2)}" stroke-linejoin="round"`);
    html+=`<g clip-path="url(#${id}c)" fill="none" stroke="var(--blanc)" stroke-width="${f1(lis*2)}" stroke-linejoin="round">${gouttes.map((g,i)=>`<path d="${g.trait}" ${anim(g,i)}/>`).join('')}</g>`;
    html+=lettres(c=>`url(#${id}${c[0]})`);
    html+=lettres(c=>`url(#${id}t${c[0]})`);
    html+=`<g clip-path="url(#${id}c)">${gouttes.map((g,i)=>`<path d="${g.plein}" fill="${encre(g)}" ${anim(g,i)}/>`).join('')}</g>`;
    /* l'astérisque reste la marque : lilas plein, une seule goutte lilas */
    if(ast){const ra=(ast.querySelector('.etoile')||ast).getBoundingClientRect(),xa=f1(ra.left-hb.left),ya=f1(ra.top-hb.top),la=f1(ra.width),ha=f1(ra.height);html+=`<mask id="${id}e" maskUnits="userSpaceOnUse"><image href="${MP_ASSETS['img/marque/etoile.png']}" x="${xa}" y="${ya}" width="${la}" height="${ha}"/></mask><rect x="${xa}" y="${ya}" width="${la}" height="${ha}" fill="var(--blanc)" mask="url(#${id}e)"/>`}
    e.innerHTML=html;
    h.appendChild(e);h.classList.add('fondu');
    h._perles=gouttes.filter(g=>g.longue).map(g=>({x:g.x,bas:g.bas,r:g.r,c:encre(g)}))};
  /* de temps en temps, une perle se détache d'une longue coulure */
  const goutter=z=>{
    if(reducedFx())return;const ps=(z._perles||[]).filter(p=>p.r>2.5);if(!ps.length)return;
    const g=ps[Math.floor(Math.random()*ps.length)],r=g.r,p=document.createElement('i');
    p.className='chute';p.style.cssText=`left:${f1(g.x-r*.8)}px;top:${f1(g.bas-r*1.6)}px;width:${f1(r*1.6)}px;height:${f1(r*1.6)}px;background:${g.c};box-shadow:0 0 0 1.5px var(--blanc)`;
    z.appendChild(p);
    p.animate([{transform:'translateY(0) scaleY(1)',opacity:1},{transform:`translateY(${60+r*14}px) scaleY(1.25)`,opacity:1,offset:.8},{transform:`translateY(${80+r*18}px) scaleY(1.3)`,opacity:0}],
      {duration:1100+r*40,easing:'cubic-bezier(.5,0,.9,.6)'}).onfinish=()=>p.remove()};
  /* ESSAI LOCAL · fiche 667 sur téléphone : la photo coule dans la feuille, comme le film de l'accueil.
     La feuille est percée de festons qui laissent voir la photo prolongée dessous, cernés du même liseré ;
     les gouttes suivent le bord de la feuille quand elle monte. Appelé par initFiche, la pièce une fois connue. */
  window.couleFeuille=fiche=>{
    const info=fiche.querySelector('.fiche-info');if(!info)return;info.querySelector('svg.feuille-liseré')?.remove();
    if(!fiche.classList.contains('coule-fiche')||innerWidth>820){fiche.style.removeProperty('--D');fiche.style.removeProperty('--masque');return}
    const W=info.clientWidth,k=.62,ov=3,lis=1.3,rnd=hasard(2026);
    const gouttes=festonner(0,W,ov,{rnd,ov,pLongue:.22,wMin:18*k,wMax:34*k,lMin:26*k,lMax:80*k,fMin:5*k,fMax:13*k,retard:0});
    const D=Math.ceil(Math.max(...gouttes.map(g=>g.L))+ov+lis*2+2),formes=gouttes.map(g=>`<path d="${g.plein}"/>`).join('');
    const masque=`<svg xmlns="http://www.w3.org/2000/svg" width="${W}" height="${D}" viewBox="0 0 ${W} ${D}"><defs><mask id="m"><rect width="${W}" height="${D}" fill="#fff"/><g fill="#000"><rect width="${W}" height="${ov+.5}"/>${formes}</g></mask></defs><rect width="${W}" height="${D}" mask="url(#m)"/></svg>`;
    fiche.style.setProperty('--D',D+'px');fiche.style.setProperty('--masque',`url("data:image/svg+xml,${encodeURIComponent(masque)}")`);
    const id='cs'+(++nZone),e=svgEl(W,D);e.classList.add('feuille-liseré');
    e.innerHTML=`<defs><linearGradient id="${id}g" gradientUnits="userSpaceOnUse" x1="0" x2="0" y1="${ov+3}" y2="${ov+22*k}"><stop offset="0" stop-color="#000"/><stop offset="1" stop-color="#fff"/></linearGradient>`+
      `<linearGradient id="${id}f" gradientUnits="userSpaceOnUse" x1="0" x2="0" y1="${ov}" y2="${D}"><stop offset="0" stop-color="#F4F4F2" stop-opacity="0"/><stop offset="1" stop-color="#F4F4F2" stop-opacity=".2"/></linearGradient>`+
      `<mask id="${id}" maskUnits="userSpaceOnUse"><rect width="${W}" height="${D}" fill="url(#${id}g)"/><g fill="#000"><rect width="${W}" height="${ov+.5}"/>${formes}</g></mask></defs>`+
      `<g fill="url(#${id}f)">${formes}</g>`+
      `<g mask="url(#${id})" fill="none" stroke="var(--blanc)" stroke-width="${lis*2}" stroke-linejoin="round">${gouttes.map(g=>`<path d="${g.trait}"/>`).join('')}</g>`;
    info.prepend(e)};
  /* dernier appel : les bords qui coulent. En haut de la bande, l'encre de l'imprimé (bleu puis rouge, liseré blanc) ;
     sous le bouton, sa propre peinture (couleur du bouton, sans liseré). Même tirage fixe, même chute des gouttes que le titre. */
  const tracerBord=(el,ou)=>{
    el.querySelector(':scope>svg.coulures')?.remove();
    const W=el.clientWidth;if(!W)return;
    const haut=ou==='haut',k=haut?(innerWidth<821?.62:1):.3,ov=haut?4:2,lis=1.3,id='cb'+(++nZone);
    const gouttes=festonner(0,W,ov,{rnd:hasard(haut?3110:2359),ov,pLongue:haut?.16:.2,wMin:16*k,wMax:30*k,lMin:22*k,lMax:72*k,fMin:3*k,fMax:9*k,retard:haut?.8:.4});
    const D=Math.ceil(Math.max(...gouttes.map(g=>g.L))+ov+lis*2+4),e=svgEl(W,D),xs=W/2;
    const encre=g=>haut?(g.x<xs?ENCRE.bleu.goutte:ENCRE.rouge.goutte):'currentColor';
    let html=`<defs><clipPath id="${id}"><rect width="${W}" height="${D}"/></clipPath></defs>`;
    if(haut)html+=`<rect width="${f1(xs)}" height="${ov}" fill="${ENCRE.bleu.moyen}"/><rect x="${f1(xs)}" width="${f1(W-xs)}" height="${ov}" fill="${ENCRE.rouge.moyen}"/>`+
      `<g clip-path="url(#${id})" fill="none" stroke="var(--blanc)" stroke-width="${f1(lis*2)}" stroke-linejoin="round">${gouttes.map((g,i)=>`<path d="${g.trait}" ${anim(g,i)}/>`).join('')}</g>`;
    html+=`<g clip-path="url(#${id})">${gouttes.map((g,i)=>`<path d="${g.plein}" fill="${encre(g)}" ${anim(g,i)}/>`).join('')}</g>`;
    e.innerHTML=html;
    const y0=haut?0:el.clientHeight-ov;if(!haut)e.style.top=y0+'px';
    el.prepend(e);
    el._perles=gouttes.filter(g=>g.longue).map(g=>({x:g.x,bas:y0+g.bas,r:g.r,c:haut?encre(g):'var(--blanc)'}))};
  const zones=[];
  document.querySelectorAll('[data-coule-bord]').forEach(t=>zones.push({el:t,tracer:()=>tracerBord(t,'haut')}));
  document.querySelectorAll('[data-coule-bas]').forEach(t=>zones.push({el:t,tracer:()=>tracerBord(t,'bas')}));
  const film=document.querySelector('.hero-drop');
  if(film)zones.push({el:film,tracer:()=>tracerFilm(film),vu:r=>r.bottom<innerHeight*.94&&r.bottom>0});
  document.querySelectorAll('[data-coule]').forEach(t=>zones.push({el:t,tracer:()=>tracerTitre(t)}));
  if(zones.length){
    const lancer=()=>{
      zones.forEach(z=>{z.el.dataset.goutte='';z.tracer();
        const vu=()=>{const r=z.el.getBoundingClientRect();return z.vu?z.vu(r):r.top<innerHeight*.9&&r.bottom>0};
        const couler=()=>{if(z.el.classList.contains('coule'))return;z.el.classList.add('coule');
          setTimeout(()=>setInterval(()=>{if(vu()&&!document.hidden)goutter(z.el)},2600),2600)};
        if('IntersectionObserver' in window)new IntersectionObserver((es,o)=>es.forEach(e=>{if(e.isIntersecting&&vu()){couler();o.disconnect()}}),{threshold:[0,.3,.7]}).observe(z.el);
        const auScroll=()=>{if(vu()){couler();removeEventListener('scroll',auScroll)}};
        addEventListener('scroll',auScroll,{passive:true});auScroll()});
      let lw=innerWidth,t;
      addEventListener('resize',()=>{if(innerWidth===lw)return;lw=innerWidth;clearTimeout(t);t=setTimeout(()=>zones.forEach(z=>z.tracer()),200)});
    };
    (document.fonts&&document.fonts.ready?document.fonts.ready:Promise.resolve()).then(lancer);
  }
  /* billet : le tampon tombe une fois, quand le billet est bien à l'écran.
     Deux déclencheurs (observateur + défilement) : un observateur muet laisserait le tampon invisible. */
  const billet=document.querySelector('.billet');
  if(billet){
    const composer=()=>{if(billet.classList.contains('compose'))return;setTimeout(()=>billet.classList.add('compose'),450)};
    const vu=()=>{const b=billet.getBoundingClientRect();return b.top<innerHeight*.78&&b.bottom>0};
    if('IntersectionObserver' in window)new IntersectionObserver((es,o)=>es.forEach(e=>{if(e.isIntersecting&&vu()){composer();o.disconnect()}}),{threshold:[0,.4,.8]}).observe(billet);
    const auScroll=()=>{if(vu()){composer();removeEventListener('scroll',auScroll)}};
    addEventListener('scroll',auScroll,{passive:true});auScroll();
  }
  /* ligne 667 : tableau des départs à palettes. Chaque case bat quelques lettres au hasard avant de se fixer ;
     le statut de chaque étape vient de la date du jour (parti, à quai, en approche, prévu). */
  const tableau=document.querySelector('.tableau');
  if(tableau){
    const lignes=[...tableau.querySelectorAll('.tb-lignes li')],now=Date.now(),dates=lignes.map(li=>+new Date(li.dataset.date));
    const finLigne=+new Date(lignes.at(-1).dataset.fin||lignes.at(-1).dataset.date);
    let cur=-1;dates.forEach((d,i)=>{if(d<=now)cur=i});
    const etat=i=>now>finLigne?(i===lignes.length-1?['arrive','ARRIVÉ']:['parti','PARTI']):
      i<cur?['parti','PARTI']:i===cur?['quai','À QUAI']:i===cur+1?['approche','EN APPROCHE']:['prevu','PRÉVU'];
    const LARG={jour:8,dest:11,statut:11},HASARD='ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    const cases=(n,txt)=>{const t=[...txt.padEnd(n,' ')].slice(0,n);return t.map(()=>'<span class="pl"></span>').join('')};
    const aPoser=[];
    lignes.forEach((li,r)=>{
      const [cle,mot]=etat(r);li.dataset.etat=cle;
      const via=li.querySelector('.tb-via'),txt=li.querySelector('.tb-txt');
      const champs={jour:li.dataset.jour,dest:li.dataset.dest,statut:mot};
      const html=`<span class="tb-lampe" aria-hidden="true"></span>`+Object.entries(champs).map(([k,v])=>`<span class="tb-f tb-${k}" aria-hidden="true">${cases(LARG[k],v)}</span>`).join('')+
        `<span class="tb-meta" aria-hidden="true">${li.dataset.jour} · <b>${mot}</b></span>`;
      txt.insertAdjacentHTML('beforebegin',html);txt.textContent=`${txt.textContent} · ${mot}`;txt.classList.add('vh');
      Object.entries(champs).forEach(([k,v],c)=>{const tuiles=[...li.querySelectorAll(`.tb-${k} .pl`)],lettres=[...v.padEnd(LARG[k],' ')];
        tuiles.forEach((el,j)=>aPoser.push({el,cible:lettres[j]===' '?'':lettres[j],r,c:j+(k==='dest'?9:k==='statut'?21:0)}))});
      if(via)li.appendChild(via)});
    tableau.classList.add('monte');
    const clac=el=>el.animate([{transform:'scaleY(.3)'},{transform:'none'}],{duration:70,easing:'ease-out'});
    const battre=(el,cible,delai,tours)=>{let n=0;
      const pas=()=>{if(n<tours){el.textContent=HASARD[Math.random()*HASARD.length|0];clac(el);n++;setTimeout(pas,52+Math.random()*30)}
        else{el.textContent=cible;if(tours)clac(el)}};
      setTimeout(pas,delai)};
    let fait=false;
    const afficher=()=>{if(fait)return;fait=true;
      if(reducedFx()){aPoser.forEach(x=>x.el.textContent=x.cible);return}
      aPoser.forEach(x=>battre(x.el,x.cible,x.r*150+x.c*26,x.cible?6+(Math.random()*9|0):(Math.random()<.35?2+(Math.random()*3|0):0)))};
    const vu=()=>{const r=tableau.getBoundingClientRect();return r.top<innerHeight*.85&&r.bottom>0};
    if('IntersectionObserver' in window)new IntersectionObserver((es,o)=>es.forEach(e=>{if(e.isIntersecting&&vu()){afficher();o.disconnect()}}),{threshold:[0,.3,.6]}).observe(tableau);
    const auScroll=()=>{if(vu()){afficher();removeEventListener('scroll',auScroll)}};
    addEventListener('scroll',auScroll,{passive:true});auScroll();
    /* l'heure de Genève en palettes : seules les cases qui changent battent */
    const heure=tableau.querySelector('.tb-heure');
    if(heure){heure.innerHTML=cases(5,'');const hp=[...heure.children];
      const maj=()=>{const t=new Date().toLocaleTimeString('fr-CH',{hour:'2-digit',minute:'2-digit',timeZone:'Europe/Zurich'}).replace('.',':');
        [...t].forEach((ch,i)=>{if(hp[i]&&hp[i].textContent!==ch){hp[i].textContent=ch;if(!reducedFx())clac(hp[i])}})};
      maj();setInterval(maj,15000)}
  }
  /* ancres internes (#drop) : défilement adouci par Lenis s'il tourne */
  document.addEventListener('click',e=>{
    const a=e.target.closest('a[href^="#"]');if(!a||a.getAttribute('href').length<2)return;
    const cible=document.querySelector(a.getAttribute('href'));if(!cible)return;
    e.preventDefault();document.querySelector('.menu')?.classList.remove('open');
    if(window.__lenis)window.__lenis.scrollTo(cible,{offset:-20,duration:1.2});else cible.scrollIntoView({behavior:'smooth'});
  });
  /* arrivée depuis une autre page sur /#drop : Lenis a besoin d'un coup de pouce */
  if(location.hash==='#drop')addEventListener('load',()=>{const c=document.querySelector('#drop');
    if(c&&window.__lenis)setTimeout(()=>window.__lenis.scrollTo(c,{offset:-20,immediate:true}),60)});
})();
function reducedFx(){return matchMedia('(prefers-reduced-motion: reduce)').matches}

/* ================= DEVISES (mêmes marchés que la boutique Shopify réelle) ================= */
const Cur={
 get(){return MP_SHOPIFY.currency||'CHF'},
 fmt(value){return new Intl.NumberFormat('fr-CH',{style:'currency',currency:Cur.get()}).format(value)},
 apply(){document.querySelectorAll('[data-chf]').forEach(el=>el.textContent=Cur.fmt(+el.dataset.chf))},
 /* 15.10.2026 : le choix de devise change vraiment de marché Shopify (formulaire /localization) ; les pays et devises
    sont ceux activés dans leur boutique. Les prix reviennent de Shopify dans la nouvelle devise. */
 aller(cur){const cs=MP_SHOPIFY.countries||[],pref={CHF:'CH',EUR:'FR',USD:'US',GBP:'GB',CAD:'CA'};
  const c=(cs.find(x=>x[0]===MP_SHOPIFY.country&&x[1]===cur)||cs.find(x=>x[0]===pref[cur]&&x[1]===cur)||cs.find(x=>x[1]===cur)||[])[0];
  if(!c)return;const f=document.createElement('form');f.method='post';f.action='/localization';
  for(const [k,v] of [['form_type','localization'],['utf8','✓'],['_method','put'],['return_to',location.pathname+location.search],['country_code',c]]){const i=document.createElement('input');i.type='hidden';i.name=k;i.value=v;f.append(i)}
  document.body.append(f);f.submit()},
 init(){const cur=Cur.get(),list=[...new Set((MP_SHOPIFY.countries||[]).map(x=>x[1]))];if(!list.includes(cur))list.unshift(cur);
  document.querySelectorAll('.cur-sel').forEach(s=>{s.replaceChildren(...list.map(x=>new Option(x,x,x===cur,x===cur)));s.disabled=list.length<2;
   s.onchange=()=>{if(s.value!==cur)Cur.aller(s.value)}});Cur.apply()}
};
Cur.init();

/* ================= PANIER (persistant, toutes pages) ================= */
const Cart={
  get(){return MP.items},
  add(it){return MP.add(it)},
  rm(i){return MP.remove(i)},
  total(){return MP.total/100},
  open(){document.body.classList.remove('fav-open');document.body.classList.add('cart-open')},
  close(){document.body.classList.remove('cart-open')},
  render(){
    const c=Cart.get(),n=c.reduce((s,x)=>s+x.q,0);
    document.querySelectorAll('.panier').forEach(a=>a.textContent=`PANIER (${n})`);
    document.querySelectorAll('.nb-panier').forEach(b=>{b.textContent=n||'';b.classList.toggle('vide',!n)});
    const box=document.querySelector('.cart-items');if(!box)return;
    box.innerHTML=c.length?c.map((x,i)=>`<div class="cart-it">
      <img src="${x.img}" alt=""><div><div class="ci-nom">${x.nom}</div>
      <div class="ci-meta">${x.code} ${x.taille?'· '+(x.optNom||'TAILLE')+' '+x.taille:''} ${x.q>1?'· ×'+x.q:''}${x.preco?'<span class="ci-preco">PRÉCOMMANDE · LIVRAISON 6 À 8 SEM. APRÈS LE 31.10</span>':''}</div></div>
      <div style="text-align:right">${Cur.fmt(x.prix*x.q)}<br><button data-rm="${i}" aria-label="Retirer">✕</button></div></div>`).join('')
      :'<p class="cart-vide">VOTRE PANIER EST VIDE *</p>';
    const t=document.querySelector('.cart-total span:last-child');if(t)t.textContent=Cur.fmt(Cart.total());
    const cp=document.querySelector('.cart-preco');
    if(cp)cp.hidden=!c.some(x=>x.preco);
  },
  init(){
    const d=document.createElement('div');
    d.innerHTML=`<div class="cart-overlay"></div><aside class="cart-drawer" aria-label="Panier">
      <div class="cart-head"><span>PANIER *</span><button class="cart-close">FERMER ✕</button></div>
      <div class="cart-items" data-lenis-prevent></div>
      <div class="cart-foot"><p class="cart-preco" hidden>VOTRE PANIER CONTIENT DES PIÈCES EN PRÉCOMMANDE : ELLES SONT PRODUITES APRÈS LA CLÔTURE DU 31.10 ET EXPÉDIÉES 6 À 8 SEMAINES PLUS TARD.</p><div class="cart-total"><span>TOTAL</span><span>CHF 0</span></div>
      <button class="btn-panier cart-order">COMMANDER</button>
      <p class="cart-note">FRAIS DE LIVRAISON CALCULÉS AU PAIEMENT</p></div></aside>`;
    document.body.append(...d.children);
    document.querySelector('.cart-overlay').addEventListener('click',Cart.close);
    document.querySelector('.cart-close').addEventListener('click',Cart.close);
    document.querySelector('.cart-order').addEventListener('click',()=>MP.checkout());
    document.querySelector('.cart-items').addEventListener('click',e=>{
      const b=e.target.closest('[data-rm]');if(b)Cart.rm(+b.dataset.rm)});
    document.querySelectorAll('.panier,.panier-ic').forEach(a=>a.addEventListener('click',e=>{e.preventDefault();
      const m=document.querySelector('.menu');if(m)m.classList.remove('open');Cart.open()}));
    Cart.render();
  }
};
Cart.init();
MP.refresh();

/* ================= FAVORIS : retirés à la demande du client (13.10.2026) ================= */
const Fav={get(){return[]},set(){},has(){return false},toggle(){},open(){},close(){},render(){},init(){}};
function injectFavs(){}

/* ================= RECHERCHE INSTANTANÉE (loupe nav) ================= */
(function(){
  if(typeof PRODUITS==='undefined')return;
  const btns=document.querySelectorAll('.s-btn');if(!btns.length)return;
  const d=document.createElement('div');
  d.innerHTML=`<div class="search-ov" data-lenis-prevent>
    <div class="search-row">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.5" y2="16.5"/></svg>
      <input type="search" placeholder="NOM, CODE (A0*), TYPE…" aria-label="Rechercher un produit">
      <button class="search-x">FERMER ✕</button>
    </div>
    <p class="search-meta">TAPER POUR CHERCHER · ${Object.keys(PRODUITS).length} RÉF.</p>
    <div class="search-res grid"></div></div>`;
  document.body.append(d.firstElementChild);
  const ov=document.querySelector('.search-ov'),inp=ov.querySelector('input'),
        res=ov.querySelector('.search-res'),meta=ov.querySelector('.search-meta');
  ov.setAttribute('data-lenis-prevent','');
  const open=()=>{document.body.classList.add('search-open');document.documentElement.classList.add('fige');window.__lenis?.stop();
    document.querySelector('.menu')?.classList.remove('open');setTimeout(()=>inp.focus(),80)};
  const close=()=>{document.body.classList.remove('search-open');document.documentElement.classList.remove('fige');window.__lenis?.start()};
  btns.forEach(b=>b.addEventListener('click',open));
  ov.querySelector('.search-x').addEventListener('click',close);
  addEventListener('keydown',e=>{if(e.key==='Escape')close()});
  const norm=s=>s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'');
  /* synonymes FR par type + par mot du nom (justes, jamais approximatifs) */
  const SYNT={vestes:'veste jacket blouson',hoodies:'pull sweat sweatshirt capuche',
    tees:'tshirt t-shirt tee-shirt shirt haut manches',pantalons:'pantalon jogging bas survet survetement',
    accessoires:'accessoire'};
  const SYNM=[['CASQUETTE','cap trucker'],['TRUCKER','casquette cap'],['TUMBLER','gobelet tasse cup'],['PARAPLUIE','umbrella'],['BEANIE','bonnet'],['SKULL','bonnet'],['SCARF','echarpe foulard'],
    ['SKI MASK','cagoule masque'],['UMBRELLA','parapluie'],['DUFFLE','sac bag'],
    ['REFLECTIVE','reflechissant reflective'],['THERMO','thermosensible'],['LONGSLEEVE','manches longues'],
    ['CREWNECK','col rond sweat'],['HOODIE','hoodie capuche'],['TRACK','survet survetement']];
  /* recherche par mots entiers : « shirt » ne doit pas trouver le hoodie via « sweatshirt », ni « cap » via « capuche ».
     Un mot qui existe tel quel dans le catalogue ne cherche que lui ; sinon c'est un mot en cours de frappe, on cherche par le début.
     T-shirt s'écrit de toutes les façons, et le pluriel ne compte pas (casquettes = casquette). */
  const sing=w=>w.length>3&&w.endsWith('s')?w.slice(0,-1):w;
  const mots=s=>norm(s).replace(/\b(t|tee)[\s-]*shirt/g,'tshirt').split(/[^a-z0-9]+/).filter(Boolean).map(sing);
  const IDX={};Object.keys(PRODUITS).forEach(h=>{const p=PRODUITS[h];
    let t=p.nom+' '+p.code+' '+p.type+' '+p.ligneNom+' '+(SYNT[p.type]||'')+(p.ligne==='667'?' collab precommande':'');
    SYNM.forEach(([k,v])=>{if(p.nom.toUpperCase().includes(k))t+=' '+v});IDX[h]=new Set(mots(t))});
  const TOUS=new Set(Object.values(IDX).flatMap(m=>[...m]));
  const trouve=(h,w)=>TOUS.has(w)?IDX[h].has(w):[...IDX[h]].some(t=>t.startsWith(w));
  inp.addEventListener('input',()=>{
    const q=mots(inp.value);
    if(!q.length){res.innerHTML='';meta.textContent=`TAPER POUR CHERCHER · ${Object.keys(PRODUITS).length} RÉF.`;return}
    const hits=Object.keys(PRODUITS).filter(h=>q.every(w=>trouve(h,w)));
    meta.textContent=hits.length?hits.length+' RÉSULTAT'+(hits.length>1?'S':'')+' *':'0 RÉSULTAT · ESSAYER UN TYPE (HOODIE, TEE…) *';
    res.innerHTML=hits.map(carteHTML).join('');
    injectFavs(res);
  });
})();

/* ================= CATALOGUE : filtres combinés + URL ================= */
function initFiltres(){
  let fl='all',ft='all',fd='all';
  const apply=()=>{
    let n=0;
    document.querySelectorAll('.grid .card').forEach(c=>{
      const dispo=!!c.querySelector('.badge.on'),preco=!!c.querySelector('.badge.preco');
      const ok=(fl==='all'||c.dataset.ligne===fl)&&(ft==='all'||c.dataset.type===ft)&&(fd==='all'||(fd==='on'&&dispo)||(fd==='preco'&&preco));
      c.style.display=ok?'':'none';if(ok)n++;
    });
    document.querySelectorAll('.tile-camp').forEach(t=>t.style.display=(fl==='all'&&ft==='all'&&fd==='all')?'':'none');
    document.querySelectorAll('.cat-groupe').forEach(g=>{
      const k=[...g.querySelectorAll('.card')].filter(c=>c.style.display!=='none').length;
      g.style.display=k?'':'none';
      const e=g.querySelector('.cg-n');if(e)e.textContent=k+' PIÈCE'+(k>1?'S':'')});
    const cpt=document.getElementById('compteur');if(cpt)cpt.textContent=n+' RÉF. *';
    majBarre();
    if(typeof ScrollTrigger!=='undefined')ScrollTrigger.refresh();
  };
  /* filtres fins : un tiroir fermé par défaut, et les filtres actifs rappelés en étiquettes qu'un toucher retire */
  const tiroir=document.querySelector('.cat-tiroir'),bf=document.querySelector('.btn-filtrer'),actifs=document.querySelector('.cat-actifs');
  if(bf&&tiroir)bf.addEventListener('click',()=>{const o=tiroir.classList.toggle('ouvert');bf.setAttribute('aria-expanded',o)});
  function majBarre(){
    if(!actifs)return;
    const liste=[['type',ft],['dispo',fd]].filter(x=>x[1]!=='all');
    const n=document.querySelector('.bf-n');if(n)n.textContent=liste.length||'';
    actifs.innerHTML='';
    liste.forEach(([dim,val])=>{const src=document.querySelector(`.filtres[data-dim="${dim}"] button[data-f="${val}"]`);if(!src)return;
      const b=document.createElement('button');b.textContent=src.textContent+' ✕';b.setAttribute('aria-label','Retirer le filtre '+src.textContent);
      b.addEventListener('click',()=>{setBtn(dim,'all');if(dim==='type')ft='all';else fd='all';apply()});actifs.appendChild(b)});
  }
  const setBtn=(dim,val)=>{
    const b=document.querySelector(`.filtres[data-dim="${dim}"] button[data-f="${val}"]`);
    if(!b)return false;
    document.querySelectorAll(`.filtres[data-dim="${dim}"] button`).forEach(x=>x.classList.remove('active'));
    b.classList.add('active');return true;
  };
  document.querySelectorAll('.filtres button').forEach(b=>b.addEventListener('click',()=>{
    const dim=b.closest('.filtres').dataset.dim;
    setBtn(dim,b.dataset.f);
    if(dim==='ligne')fl=b.dataset.f;else if(dim==='type')ft=b.dataset.f;else fd=b.dataset.f;
    apply();
  }));
  const q=new URLSearchParams(location.search);
  if(q.get('type')&&setBtn('type',q.get('type')))ft=q.get('type');
  if(q.get('ligne')&&setBtn('ligne',q.get('ligne')))fl=q.get('ligne');
  if(q.get('dispo')&&setBtn('dispo','on'))fd='on';
  if(q.get('preco')&&setBtn('dispo','preco'))fd='preco';
  apply();initRestock();
}
function initRestock(){
  document.querySelectorAll('.btn-restock:not([data-ok])').forEach(b=>{b.dataset.ok=1;
    b.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();
      location.href='/pages/contact'})});
}

/* ================= LIGHTBOX ZOOM (galerie fiche) ================= */
const LB={imgs:[],i:0};
function lbOpen(imgs,i){
  LB.imgs=imgs;LB.i=i;
  let ov=document.querySelector('.lb-ov');
  if(!ov){
    const d=document.createElement('div');
    d.innerHTML=`<div class="lb-ov" hidden><button class="lb-x">FERMER ✕</button>
      <button class="lb-prev" aria-label="Précédente">‹</button>
      <div class="lb-stage"><img alt="Zoom produit"></div>
      <button class="lb-next" aria-label="Suivante">›</button>
      <p class="lb-count"></p></div>`;
    document.body.append(d.firstElementChild);
    ov=document.querySelector('.lb-ov');
    const img=ov.querySelector('img'),stage=ov.querySelector('.lb-stage');
    const dez=()=>{if(LB.reset)LB.reset();else{img.classList.remove('zoom');img.style.transform=''}};
    const nav=d2=>{LB.i=(LB.i+d2+LB.imgs.length)%LB.imgs.length;img.src=LB.imgs[LB.i];
      ov.querySelector('.lb-count').textContent=(LB.i+1)+' / '+LB.imgs.length;dez()};
    ov.querySelector('.lb-x').addEventListener('click',()=>ov.hidden=true);
    ov.querySelector('.lb-prev').addEventListener('click',()=>nav(-1));
    ov.querySelector('.lb-next').addEventListener('click',()=>nav(1));
    ov.addEventListener('click',e=>{if(e.target===ov)ov.hidden=true});
    addEventListener('keydown',e=>{if(ov.hidden)return;
      if(e.key==='Escape')ov.hidden=true;if(e.key==='ArrowLeft')nav(-1);if(e.key==='ArrowRight')nav(1)});
    /* moteur zoom tactile : pincer = zoomer, toucher = zoom rapide,
       glisser = se déplacer (image bloquée dans le cadre), balayer = photo suivante */
    const Z={ptrs:new Map(),scale:1,tx:0,ty:0,sx:0,sy:0,stx:0,sty:0,d0:0,s0:1,moved:false};
    const apply=()=>{img.classList.toggle('zoom',Z.scale>1.01);
      img.style.transform=Z.scale>1.01?`translate(${Z.tx}px,${Z.ty}px) scale(${Z.scale})`:''};
    const clamp=()=>{const r=stage.getBoundingClientRect();
      const mx=r.width*(Z.scale-1)/2,my=r.height*(Z.scale-1)/2;
      Z.tx=Math.max(-mx,Math.min(mx,Z.tx));Z.ty=Math.max(-my,Math.min(my,Z.ty))};
    LB.reset=()=>{Z.scale=1;Z.tx=Z.ty=0;apply()};
    img.addEventListener('pointerdown',e=>{e.preventDefault();
      Z.ptrs.set(e.pointerId,e);Z.moved=false;img.setPointerCapture(e.pointerId);
      if(Z.ptrs.size===1){Z.sx=e.clientX;Z.sy=e.clientY;Z.stx=Z.tx;Z.sty=Z.ty}
      else if(Z.ptrs.size===2){const[a,b]=[...Z.ptrs.values()];
        Z.d0=Math.hypot(a.clientX-b.clientX,a.clientY-b.clientY);Z.s0=Z.scale}});
    img.addEventListener('pointermove',e=>{if(!Z.ptrs.has(e.pointerId))return;
      Z.ptrs.set(e.pointerId,e);
      if(Z.ptrs.size===2){const[a,b]=[...Z.ptrs.values()];
        const d=Math.hypot(a.clientX-b.clientX,a.clientY-b.clientY);
        Z.scale=Math.min(3,Math.max(1,Z.s0*d/Z.d0));Z.moved=true;clamp();apply()}
      else{const dx=e.clientX-Z.sx,dy=e.clientY-Z.sy;
        if(Math.abs(dx)+Math.abs(dy)>8)Z.moved=true;
        if(Z.scale>1.01){Z.tx=Z.stx+dx;Z.ty=Z.sty+dy;clamp();apply()}}});
    const fin=e=>{if(!Z.ptrs.has(e.pointerId))return;Z.ptrs.delete(e.pointerId);
      if(Z.ptrs.size)return;
      if(Z.moved){if(Z.scale<=1.01){const dx=e.clientX-Z.sx;
        if(dx<-55)nav(1);else if(dx>55)nav(-1)}return}
      if(Z.scale>1.01){LB.reset()}
      else{const r=img.getBoundingClientRect();Z.scale=2.2;
        Z.tx=-(e.clientX-(r.left+r.width/2))*Z.scale;
        Z.ty=-(e.clientY-(r.top+r.height/2))*Z.scale;clamp();apply()}};
    img.addEventListener('pointerup',fin);img.addEventListener('pointercancel',fin);
    ov.dataset.ready=1;
  }
  const img=ov.querySelector('img');
  img.src=LB.imgs[LB.i];
  if(LB.reset)LB.reset();else{img.classList.remove('zoom');img.style.transform=''}
  ov.querySelector('.lb-count').textContent=(LB.i+1)+' / '+LB.imgs.length;
  ov.hidden=false;
}

/* ================= FICHE PRODUIT DYNAMIQUE ================= */
function carteHTML(h){
  const p=PRODUITS[h];
  const badge=p.preco?'<span class="badge preco">PRÉCOMMANDE</span>':p.dispo?'<span class="badge on">DISPO</span>':'<span class="badge">ÉPUISÉ</span>';
  const im2=p.images[1]?`<img class="im2" src="${TAILLE(p.images[1],800)}" srcset="${JEU_T(p.images[1])}" sizes="(max-width:820px) 50vw, 25vw" alt="" loading="lazy">`:'';
  return `<div class="card" data-ligne="${p.ligne}" data-type="${p.type}"${p.couleur?` data-couleur="${p.couleur}"`:''}>
    <a href="/products/${h}"><div class="card-img"><img src="${TAILLE(p.images[0],800)}" srcset="${JEU_T(p.images[0])}" sizes="(max-width:820px) 50vw, 25vw" alt="${p.nom}" loading="lazy">${im2}</div>
    <div class="card-info"><span class="code">${p.code}</span><span class="nom">${p.nom}</span>
    <div class="ligne-prix"><span data-chf="${p.prix}">${Cur.fmt(p.prix)}</span>${badge}</div></div></a></div>`;
}
function initFiche(){
  const q=new URLSearchParams(location.search);
  /* sans paramètre : la pièce phare du drop */
  const h=MP_SHOPIFY.handle || q.get('p') || Object.keys(PRODUITS)[0];
  const p=PRODUITS[h];
  document.title=`${p.nom} · ${p.code} · Maison Piège*`;
  const fiche=document.querySelector('.fiche');
  if(p.couleur)fiche.dataset.couleur=p.couleur;else delete fiche.dataset.couleur;
  document.getElementById('fil').innerHTML=`<a href="/collections/all" style="color:var(--beton)">CATALOGUE</a> → <b>${p.code}</b> · ${p.nom}`;
  const cl=document.querySelector('.code-line');cl.dataset.text=`${p.code} · ${p.matiere}`;
  document.getElementById('p-titre').textContent=p.nom;
  const pp=document.getElementById('p-prix');pp.dataset.chf=p.prix;pp.textContent=Cur.fmt(p.prix);
  /* précommande : leurs propres termes, et la fenêtre de livraison qui en découle */
  const box=document.getElementById('p-preco');
  if(box){
    if(p.preco){
      const fin=new Date(FIN_PRECO),j=d=>new Date(fin.getTime()+d*864e5);
      const f=d=>d.toLocaleDateString('fr-CH',{day:'2-digit',month:'2-digit',year:'2-digit'});
      box.innerHTML=`<div class="preco-box"><p><b>PRÉCOMMANDE</b> · CLÔTURE LE ${f(fin)}, MINUIT</p>
        <p>PRODUCTION ET LIVRAISON 6 À 8 SEMAINES APRÈS LA CLÔTURE : ENTRE LE ${f(j(42))} ET LE ${f(j(56))}</p>
        <p>IL RESTE <b class="cd-fiche"></b></p></div>`;
      const cd=box.querySelector('.cd-fiche'),p2=n=>String(n).padStart(2,'0');
      const tic=()=>{const r=Math.max(0,fin-Date.now());
        cd.textContent=r?`${Math.floor(r/864e5)} J ${p2(Math.floor(r/36e5)%24)} H ${p2(Math.floor(r/6e4)%60)} MIN`:'PRÉCOMMANDES CLOSES'};
      tic();setInterval(tic,15000);
    }else box.innerHTML='';
  }
  const desc=document.getElementById('p-desc');if(desc)desc.innerHTML=p.desc||'';
  /* galerie : UNIQUEMENT les photos du produit (1 seule = 1 seule), toutes, 1re en grand */
  const gal=p.images;
  document.getElementById('galerie').innerHTML=gal.map((src,i)=>
    `<div class="gal-item reflect flashable${i===0?' g-main':''}" data-i="${i}">
      <img src="${TAILLE(src,1100)}" srcset="${JEU_T(src)}, ${TAILLE(src,1600)} 1600w" sizes="(max-width:820px) 70vw, 60vw" alt="${p.nom}, vue ${i+1}"${i===0?' fetchpriority="high"':' loading="lazy"'}></div>`).join('');
  document.querySelectorAll('.gal-item').forEach(el=>el.addEventListener('click',()=>lbOpen(gal,+el.dataset.i)));
  /* ESSAI LOCAL · fiche téléphone : le fil d'Ariane passe en tête de la feuille, un compteur suit les photos,
     et sans animation liée au défilement (Safari < 26) la photo pâlit quand même, en script */
  if(matchMedia('(max-width:820px)').matches){
    const galEl=document.getElementById('galerie'),info=document.querySelector('.fiche-info'),fil=document.getElementById('fil');
    if(fil&&info)info.prepend(fil);
    const ficheEl=document.querySelector('.fiche');
    if(p.ligne==='667'&&ficheEl&&window.couleFeuille){ficheEl.classList.add('coule-fiche');window.couleFeuille(ficheEl);
      let lw=innerWidth;addEventListener('resize',()=>{if(innerWidth!==lw){lw=innerWidth;window.couleFeuille(ficheEl)}})}
    if(gal.length>1&&info){const c=document.createElement('span');c.className='gal-compte';c.setAttribute('aria-hidden','true');info.prepend(c);
      const deux=n=>String(n).padStart(2,'0'),maj=()=>{c.textContent=deux(Math.round(galEl.scrollLeft/galEl.clientWidth)+1)+' / '+deux(gal.length)};
      maj();galEl.addEventListener('scroll',maj,{passive:true})}
    if(!CSS.supports('animation-timeline: scroll()')){let t=0;
      const f=()=>{t=0;const p=Math.min(1,Math.max(0,scrollY/(info?info.offsetTop||galEl.offsetHeight:galEl.offsetHeight)));
        galEl.style.opacity=p<.55?1-.15*p/.55:.85-.69*(p-.55)/.45};
      addEventListener('scroll',()=>{if(!t)t=requestAnimationFrame(f)},{passive:true});f()}
  }
  /* infos d'achat, toutes reprises de leur boutique : coupe de leurs fiches, stock des tailles, frais d'expédition au paiement (le délai d'une précommande est dans l'encadré juste dessous).
     Leur site ne dit rien de l'entretien, des retours ni de la taille portée par le modèle : ces lignes n'existent pas ici. */
  const okT=p.tailles.filter(t=>t.ok).map(t=>t.t);
  const dispo=p.preco?`PRÉCOMMANDE JUSQU'AU ${new Date(FIN_PRECO).toLocaleDateString('fr-CH',{day:'2-digit',month:'2-digit',year:'2-digit'})}`
    :!p.dispo?'ÉPUISÉ':okT.length<p.tailles.length?`EN STOCK · ${okT.join(', ')}`:'EN STOCK';
  document.getElementById('specs').innerHTML=
    `<div class="spec"><span>LIGNE</span><span>${p.ligneNom}</span></div>
     <div class="spec"><span>MATIÈRE</span><span>${p.matiere}</span></div>
     ${p.coupe?`<div class="spec"><span>COUPE</span><span>${p.coupe}</span></div>`:''}
     <div class="spec"><span>DÉTAIL</span><span>${p.detail}</span></div>
     ${p.preco?'<div class="spec"><span>SÉRIE</span><span>PIÈCE DE LA COLLAB, TIRAGE LIMITÉ</span></div>':''}
     <div class="spec"><span>DISPONIBILITÉ</span><span>${dispo}</span></div>
     <div class="spec"><span>LIVRAISON</span><span>FRAIS D'EXPÉDITION CALCULÉS AU PAIEMENT</span></div>`;
  const tz=document.getElementById('p-tailles'),lbl=document.getElementById('lbl-taille');
  if(p.tailles.length){
    tz.innerHTML=p.tailles.map(t=>`<button class="${t.ok?'':'off'}">${t.t}</button>`).join('');
    lbl.textContent=p.optNom||'TAILLE';lbl.style.display='';
  }else{tz.innerHTML='';lbl.style.display='none'}
  /* guide des tailles : un guide général, pas les mesures de la pièce. Seulement sur les hauts à manches longues
     (poitrine et manche ne veulent rien dire sur un pantalon, et 62 cm de manche est faux pour un t-shirt) */
  const guide=document.getElementById('p-guide');
  if(guide){guide.style.display=['hoodies','vestes'].includes(p.type)?'':'none';
    document.getElementById('guide-note').textContent='MESURES INDICATIVES'+(p.coupe.includes('TRUE TO SIZE')?' · TRUE TO SIZE : PRENDS TA TAILLE HABITUELLE':'')}
  tz.querySelectorAll('button:not(.off)').forEach(b=>b.addEventListener('click',()=>{
    tz.querySelectorAll('button').forEach(x=>x.classList.remove('sel'));b.classList.add('sel')}));
  const btn=document.querySelector('.btn-panier.add');
  const libelle=p.preco?'PRÉCOMMANDER':'AJOUTER AU PANIER';
  btn.textContent=libelle;
  if(!p.dispo){btn.textContent='INDISPONIBLE · NOUS CONTACTER';
    btn.addEventListener('click',function(){location.href='/pages/contact'});
  }else btn.addEventListener('click',function(){
    const sel=tz.querySelector('.sel');
    if(p.tailles.length&&!sel){this.textContent=p.optNom==='TAILLE'?'CHOISIR UNE TAILLE':'CHOISIR UNE COULEUR';
      setTimeout(()=>this.textContent=libelle,1400);return}
    Cart.add({h,nom:p.nom,code:p.code,prix:p.prix,taille:sel?sel.textContent:'',optNom:p.optNom,preco:p.preco,img:TAILLE(p.images[0],240)});
  });
  /* associés = même ligne, rien d'autre : le titre le promet (une ligne de 3 pièces n'en montre que 2) */
  const assoc=Object.keys(PRODUITS).filter(k=>k!==h&&PRODUITS[k].ligne===p.ligne).slice(0,5);
  const boiteAssoc=document.getElementById('assoc');
  boiteAssoc.innerHTML=assoc.map(carteHTML).join('');
  if(!assoc.length)boiteAssoc.closest('section').style.display='none';
  const bf=document.getElementById('btn-fav');
  if(bf){bf.dataset.h=h;bf.addEventListener('click',()=>Fav.toggle(h))}
  /* derniers articles vus */
  let vus=[];try{vus=JSON.parse(localStorage.getItem('mp_vus')||'[]')}catch(e){}
  const avant=vus.filter(k=>k!==h&&PRODUITS[k]);
  if(avant.length){document.getElementById('sec-vus').style.display='';
    document.getElementById('vus').innerHTML=avant.slice(0,5).map(carteHTML).join('')}
  localStorage.setItem('mp_vus',JSON.stringify([h,...avant].slice(0,8)));
  initRestock();injectFavs();Fav.render();
  if(typeof bindFx==='function')bindFx();
}

/* ================= BULLE JEU (retours du 13.10.2026) : le jeu sort du menu, une bulle flottante l'ouvre ================= */
(function(){
  if(location.pathname.includes('/jeu/')||/view=jeu/.test(location.search))return;
  const a=document.createElement('a');
  a.className='bulle-jeu';a.href='/?view=jeu';a.setAttribute('aria-label','Jouer à VOIE 70*');
  a.innerHTML='<svg viewBox="0 0 44 14" aria-hidden="true"><rect x="0" y="3" width="8" height="8" fill="#2E45B8"/><rect x="10" y="3" width="8" height="8" fill="#CA273B"/><rect x="20" y="3" width="8" height="8" fill="#2E45B8"/><rect x="30" y="1.5" width="12" height="11" rx="2.5" fill="#F4F4F2"/></svg><span>JEU</span>';
  document.body.appendChild(a);
  const panier=document.querySelector('.btn-panier.add');
  if(panier&&'IntersectionObserver'in window)new IntersectionObserver(([e])=>a.classList.toggle('cachee',e.isIntersecting)).observe(panier);
})();

/* en-tête plein dès qu'on quitte le haut de page (revue du 14.10.2026) */
(function(){
  const h=document.documentElement,f=()=>h.classList.toggle('nav-pleine',scrollY>24);
  addEventListener('scroll',f,{passive:true});f();
})();

(()=>{const ok=i=>i.classList.add('mp-pret');document.addEventListener('load',e=>{if(e.target.tagName==='IMG')ok(e.target)},true);const voir=()=>document.querySelectorAll('img:not(.mp-pret)').forEach(i=>{if(i.complete&&i.naturalWidth)ok(i)});new MutationObserver(voir).observe(document.documentElement,{subtree:true,childList:true});voir()})();
